export default {
  init() {

  },
  finalize() {
    $('.ssg-anchors-inner .anchor-item.achor-item-anchor').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      
      const href = $(this).attr('href').replace('#', '');

      const $anchorElement = $(`a[name="${href}"]`);
      const anchorElementY = $anchorElement.offset().top;

      window.scrollTo(0, anchorElementY);
    });

    $(window).on('scroll', function() {
      if ($(window).scrollTop() >= ($(window).height() / 2)) {
        $('.sticky-button').addClass('show');
      } else {
        $('.sticky-button').removeClass('show');
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateStartSomethingGood.js